import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Edit, Trash2 } from "lucide-react";

const UpcomingAppointments = ({
  appointments,
  onEdit,
  onDelete
}) => {
  return (
    <Card className="border border-border shadow-sm rounded-sm" data-testid="upcoming-appointments">
      <CardHeader>
        <CardTitle className="font-heading text-lg">Prossimi Appuntamenti</CardTitle>
      </CardHeader>
      <CardContent>
        {appointments.length > 0 ? (
          <div className="divide-y divide-border">
            {appointments.map(apt => (
              <div key={apt.appointment_id} className="py-3 flex justify-between items-center">
                <div>
                  <p className="font-medium text-sm">{apt.title}</p>
                  <p className="text-xs text-muted-foreground">
                    {new Date(apt.date).toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" })}
                    {apt.time && ` alle ${apt.time}`}
                  </p>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => onEdit(apt)}
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    <Edit className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => onDelete(apt.appointment_id)}
                    className="text-muted-foreground hover:text-destructive transition-colors"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground text-center py-4">
            Nessun appuntamento in programma
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default UpcomingAppointments;
